export default __webpack_public_path__ + "static/media/logo-rounded.b4df1ec9.png";